<div class="modal-header" *ngIf="relationship">
    <h5 class="modal-title">Assign Entity to Vendor: {{relationship.vendorName}}</h5>
    <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
</div>
<div class="modal-body" *ngIf="relationship">
    <dirty-tracking [forms]="[relationshipForm]"></dirty-tracking>
    <form novalidate #relationshipForm="ngForm" [ngClass]="{'was-validated': submitAttempt}">
        <div class="row gx-2 mb-4" *ngIf="relationship.addAssignment">
            <div class="col-md mb-3 mb-md-0 mobiscroll-select">
                <label class="form-label d-block">Top Level Account <sup class="text-danger">*</sup></label>
                <input id="move-account-input" class="mobi-input form-control form-control-lg" required placeholder="Select Account" mbsc-select [data]="accounts" [(ngModel)]="accountId" name="accountId" [mbscOptions]="accountOptions" />
            </div>
            <div class="col-md mb-3 mb-md-0 mobiscroll-select">
                <label class="form-label d-block">Entity</label>
                <input id="move-parent-input" class="mobi-input form-control form-control-lg" placeholder="Select Entity" mbsc-select [data]="parents" [(ngModel)]="parentId" name="parentId" [mbscOptions]="parentOptions" />
            </div>
        </div>
        <label class="text-strong mb-1">Selected Entity:</label>
        <nav aria-label="breadcrumb" class="mb-3">
            <ol class="breadcrumb mb-0">
                <li class="breadcrumb-item" *ngFor="let parent of relationship.hierarchy"><i class="far fa-folder text-primary"></i> {{parent.text}}</li>
                <li class="breadcrumb-item" *ngIf="relationship.hierarchy.length == 0">None</li>
            </ol>
        </nav>
        <hr *ngIf="accountId || !relationship.addAssignment" />
        <div class="row gx-3" *ngIf="accountId || !relationship.addAssignment">
            <div class="col-md mb-3 mb-md-0">
                <label class="form-label d-block">Audited</label>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="defaultsAudited" id="defaultsAuditedTrue" [value]="true" [(ngModel)]="relationship.isAudited">
                    <label class="form-check-label" for="defaultsAuditedTrue">True</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="defaultsAudited" id="defaultsAuditedFalse" [value]="false" [(ngModel)]="relationship.isAudited">
                    <label class="form-check-label" for="defaultsAuditedFalse">False</label>
                </div>
            </div>
            <div class="col-md mb-3 md-md-0">
                <label for=" vendorformularyLock" class="form-label d-block">Allow ordering under min?</label>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="defaultsOrderMin" id="defaultsOrderMinTrue" [value]="true" [(ngModel)]="relationship.allowOrderUnderMinimum">
                    <label class="form-check-label" for="defaultsOrderMinTrue">True</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="defaultsOrderMin" id="defaultsOrderMinFalse" [value]="false" [(ngModel)]="relationship.allowOrderUnderMinimum">
                    <label class="form-check-label" for="defaultsOrderMinFalse">False</label>
                </div>
            </div>
        </div>
        <div class="row gx-3" *ngIf="accountId || !relationship.addAssignment">
            <div class="col-md mb-3">
                <label for="vendorAccountNum" class="form-label">Vendor Account Number<sup class="text-danger">*</sup></label>
                <input type="text" class="form-control form-control-lg" id="vendorAccountNum" name="vendorAccountNum" placeholder="Vendor Account Number" required [(ngModel)]="relationship.vendorAccountNumber">
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md mb-3">
                <label for="billingAccountNumber" class="form-label">Billing Account Number</label>
                <input type="text" class="form-control form-control-lg" id="billingAccountNumber" name="billingAccountNumber" placeholder="Billing Account Number" [(ngModel)]="relationship.billingAccountNumber">
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3" *ngIf="accountId || !relationship.addAssignment">
            <div class="col-md mb-3">
                <label for="vendorContractNum" class="form-label">Contract Number</label>
                <input type="text" class="form-control form-control-lg" id="vendorContractNum" name="vendorContractNum" placeholder="Vendor Contract Number" [(ngModel)]="relationship.contractNumber">
            </div>
            <div class="col-md mb-3">
                <label for="vendorContractExp" class="form-label">Contract Expiration Date</label>
                <div class="input-group">
                    <span class="input-group-text"><i class="far fa-calendar"></i></span>
                    <input type="text" class="form-control form-control-lg mobi-input" mbsc-datepicker [mbscOptions]="dateOptions" id="vendorContractExp" name="vendorContractExp" placeholder="Date" [(ngModel)]="relationship.contractExpDate">
                </div>
            </div>
        </div>
        <div class="row gx-3" *ngIf="accountId || !relationship.addAssignment">
            <div class="col-md mb-3">
                <label for="vendorMinAmount" class="form-label">Minimum Order Amount</label>
                <div class="input-group">
                    <span class="input-group-text"><i class="far fa-dollar-sign"></i></span>
                    <input type="number" step="0.01" class="form-control form-control-lg" id="vendorMinAmount" name="vendorMinAmount" placeholder="Minimum Order" [(ngModel)]="relationship.minOrderAmount">
                </div>
            </div>
            <div class="col-md mb-3">
                <label for="vendorMinPenalty" class="form-label">Minimum Order Penalty</label>
                <div class="input-group">
                    <span class="input-group-text"><i class="far fa-dollar-sign"></i></span>
                    <input type="number" step="0.01" class="form-control form-control-lg" id="vendorMinPenalty" name="vendorMinPenalty" placeholder="Minimum Penalty" [(ngModel)]="relationship.minOrderPenalty">
                </div>
            </div>
            <div class="col-md mb-3">
                <label for="vendorMinPenalty" class="form-label">Additional Fees</label>
                <div class="input-group">
                    <span class="input-group-text"><i class="far fa-dollar-sign"></i></span>
                    <input type="number" step="0.01" class="form-control form-control-lg" id="vendorAddlFees" name="vendorAddlFees" placeholder="Additional Fees" [(ngModel)]="relationship.additionalFees">
                </div>
            </div>
        </div>
        <div class="row gx-3" *ngIf="(accountId || !relationship.addAssignment) && relationship.stockingLocations.length > 0">
            <div class="col-md-6 mb-3">
                <label for="stockingLocationId" class="form-label">Stocking Location</label>
                <select class="form-select form-select-lg" id="stockingLocationId" name="stockingLocationId" [(ngModel)]="relationship.stockingLocationId">
                    <option [value]="null">Select...</option>
                    <option *ngFor="let s of relationship.stockingLocations" [value]="s.value">{{s.text}}</option>
                </select>
            </div>
        </div>
        <hr *ngIf="accountId || !relationship.addAssignment" />
        <div class="accordion" id="masterAccordion" *ngIf="accountId || !relationship.addAssignment">
            <div class="row gx-3 mb-3">
                <div class="col-md-auto mb-3">
                    <div class="row align-items-end gx-3">
                        <div class="col-md-auto mb-3 mb-md-0">
                            <label for="vendorformularyLock" class="form-label d-block">Formulary Lock?</label>
                            <div class="btn-group btn-group-lg" role="group">
                                <button type="button" class="btn btn-outline-black" [ngClass]="{'active': relationship.formularyLock}" (click)="relationship.formularyLock = true; markDirty();">Yes</button>
                                <button type="button" class="btn btn-outline-black" [ngClass]="{'active': !relationship.formularyLock}" (click)="relationship.formularyLock = false; markDirty();">No</button>
                            </div>
                        </div>
                        <div class="col-md-auto">
                            <label for="vendorMaster" class="form-label d-block">Master</label>
                            <div class="btn-group btn-group-lg" role="group">
                                <button type="button" role="button" [ngClass]="{'active': relationship.masterFileInherit}" (click)="relationship.masterFileInherit = true; markDirty();" aria-expanded="false" aria-controls="masterInherit" class="btn btn-outline-black">Inherit</button>
                                <button type="button" role="button" [ngClass]="{'active': !relationship.masterFileInherit}" (click)="relationship.masterFileInherit = false; markDirty();" aria-expanded="false" aria-controls="masterChoose" class="btn btn-outline-black">Choose</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md mb-3">
                    <!-- inherit -->
                    <div class="" id="masterInherit" *ngIf="relationship.masterFileInherit">
                        <label class="text-strong mb-1">Inherited From:</label>
                        <nav aria-label="breadcrumb" class="mb-3">
                            <ol class="breadcrumb mb-0">
                                <li class="breadcrumb-item" *ngFor="let parent of relationship.masterHierarchy"><i class="far fa-folder text-primary"></i> {{parent.text}}</li>
                                <li class="breadcrumb-item" *ngIf="relationship.masterHierarchy.length == 0"><span class="badge bg-primary">None</span></li>
                            </ol>
                        </nav>
                    </div>
                    <!-- choose -->
                    <div class="" id="masterChoose" *ngIf="!relationship.masterFileInherit">
                        <label for="vendorMaster" class="form-label">Master</label>
                        <input id="choose-master-input" class="mobi-input form-control form-control-lg mb-3" placeholder="Select Master" name="choose-master-input" required mbsc-select [data]="relationship.masterFiles" [(ngModel)]="relationship.chosenMasterFileId" [mbscOptions]="masterFileOptions" />
                        <div class="invalid-feedback">
                            <i class="fas fa-exclamation-circle"></i> This field is required.
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="makeMasterFormulary" name="makeMasterFormulary" [(ngModel)]="relationship.masterIsFormulary">
                <label class="form-check-label" for="makeMasterFormulary">
                    Make this master my formulary
                </label>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer justify-content-between" *ngIf="accountId || (relationship && !relationship.addAssignment)">
    <button type="button" class="btn btn-outline-black btn-round btn-lg" (click)="dismiss()"><i class="far fa-times"></i> Cancel</button>
    <div *ngIf="relationship.addAssignment">
        <button type="button" class="btn btn-secondary btn-round btn-lg" (click)="save(true)"><i class="far fa-check"></i> Assign &
            Finish</button>
        <button type="button" class="btn btn-secondary btn-round btn-lg" (click)="save(false)"><i class="far fa-check"></i> Assign & Add
            Another</button>
    </div>
    <div *ngIf="!relationship.addAssignment">
        <button type="button" class="btn btn-secondary btn-round btn-lg" (click)="save(true)"><i class="far fa-check"></i> Save</button>
    </div>
</div>